import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import NMTCApp from './nmtc/NMTCApp';

export default function NMTCModel() {
  return (
    <div className="nmtc-page">
      <Navbar />
      <main style={{ paddingTop: '90px' }}>
        <NMTCApp />
      </main>
      <Footer />
    </div>
  );
}
